export class AdvancedNewsEnvironment {
  public static getName = () => 'benzinga-advanced-news';
  public static getEnvironment = (env: Record<string, string>) => ({
    'CF-Access-Client-Id': env.CFClientID ?? '',
    'CF-Access-Client-Secret': env.CFClientSecret ?? '',
    contentKey: env.contentKey ?? '',
    contentUrl: new URL(env.contentURL ?? 'https://content-internal.benzinga.com/content/'),
    editorialToolsUrl: new URL(env.editorialToolsUrl ?? 'https://editorial-tools.benzinga.com/api/v2/'),
    internalContentUrl: new URL(env.internalContentUrl ?? 'http://content-server-next.pro-backend'),
    keepSocketAlive: env.keepSocketAlive ?? 'false',
    socketUrl: new URL(env.socketUrl ?? 'wss://api-pro.benzinga.com/api/v3/news/advanced/ws-auth'),
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
